// Angular
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
// NGRX
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
// Translate
import {TranslateModule} from '@ngx-translate/core';
import {PartialsModule} from '../../partials/partials.module';
// Services
import {HttpUtilsService, TypesUtilsService} from '../../../core/_base/crud';
// Shared
// Components
import {UserManagementComponent} from './user-management.component';
import {UsersListComponent} from './users/users-list/users-list.component';
import {RolesListComponent} from './roles/roles-list/roles-list.component';
import {UsersDetailComponent} from './users/users-detail/users-detail.component';

// Material
import {usersReducer, UserEffects} from '../../../core/auth';

const routes: Routes = [
    {
        path: '',
        component: UserManagementComponent,
        children: [
            {
                path: '',
                redirectTo: 'roles',
                pathMatch: 'full',
            },
            {
                path: 'roles',
                data: {
                    permissions: {
                        only: ['GetRoles']
                    }
                },
                component: RolesListComponent,
            },
            {
                path: 'users',
                data: {
                    permissions: {
                        only: ['GetUsers']
                    }
                },
                component: UsersListComponent,
            },
            {
                path: 'users:id',
                component: UsersListComponent,
            },
            {
                path: 'users-detail',
                component: UsersDetailComponent,
            },
            {
                path: 'users-detail/:id',
                component: UsersDetailComponent,
            },
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        PartialsModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('users', usersReducer),
        EffectsModule.forFeature([UserEffects]),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild()
    ],
    providers: [
        HttpUtilsService,
        TypesUtilsService
    ],
    declarations: [
        UserManagementComponent,
        UsersListComponent,
        RolesListComponent,
        UsersDetailComponent
    ],
})
export class UserManagementModule {
}
